import * as React from 'react';
export const IcKnightChess = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.44 11.54l.61.2a2.11 2.11 0 002.76-2.24 2.069 2.069 0 00-1-1.57l-5.5-3.31.59-1.17a1 1 0 00-.13-1.09A1 1 0 0012.71 2a10.92 10.92 0 00-6 5.11c-1.43 2.74-1.52 6.08-.29 9.92A3 3 0 004 20v1a1 1 0 001 1h13a1 1 0 001-1v-1a3 3 0 00-2.81-3c.42-1.07-.15-2.61-1.81-4.84a.11.11 0 010-.14 2 2 0 012.06-.48z'
      fill='currentColor'
    />
  </svg>
);
